// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"f173e44c","2840":"a0cf56ad","4061":"92032edf","4774":"92032edf","4789":"f173e44c","7264":"37cf3500","8204":"f173e44c","9181":"f173e44c","9235":"f173e44c"}[chunkId] + ".chunk.css";
};